export default __webpack_public_path__ + "static/media/community.39e13615.svg";